import { Grid } from '@mui/material'

import useStyles from './index.styles'
import StatusDot from './status-dot'
import { ILocationFolder } from './types'

const StatusDots = ({ folder }: { folder: ILocationFolder }) => (
  <Grid container={true} component="span" sx={useStyles.dots}>
    {folder.hasAlerts && <StatusDot label="Alerts" testId="alert-indicator" sx={useStyles.alertDot} />}
    {folder.isIncomplete && <StatusDot label="Incomplete" testId="incomplete-indicator" sx={useStyles.incompleteDot} />}
  </Grid>
)

export default StatusDots
